import { Component, OnInit, Input, forwardRef, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Option } from 'app/model/dropdown/dropdown-option-model';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Component({
  selector: 'act-icon-dropdown',
  templateUrl: './icon-dropdown.component.html',
  styleUrls: ['./icon-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IconDropdownComponent),
      multi: true
    }
  ]
})
export class IconDropdownComponent implements OnInit, OnChanges, ControlValueAccessor, AfterViewInit {
  @Input() page: string;
  @Input() name: string;
  @Input() optionList: Option[];
  @Input() default?: Option;
  @Input() hideRowWhenImgError = true;
  @Input() displayIcon = true;
  @Input() defaultValue = 'Please select';
  @Input() isError = false;
  @Input() disabled = false;

  onChange: Function;
  onTouch: Function;
  private value: string;
  public currentOption: Option;
  public buttonWidth = 0;
  public menuClassName = 'dropdown-sub-menu';
  public isOpenMenu = false;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.optionList) {
      if (changes.optionList.currentValue) {
        if (this.value) {
          const newOption = changes.optionList.currentValue.find(x => x.value === this.value);
          this.currentOption = newOption;
          this.value = newOption.value;
        }
      } else {
        this.currentOption = this.default;
      }
    }
  }

  onOpenMenu() {
    this.isOpenMenu = true;
  }

  onCloseMenu() {
    this.isOpenMenu = false;
  }

  ngOnInit() {
    if (this.displayIcon) {
      this.menuClassName += ' -divide-first -max-content-width';
    } else {
      this.menuClassName += ' -fluid-width';
    }
  }

  ngAfterViewInit() {
    if (!this.displayIcon) {
      this.buttonWidth = document.getElementById(`${this.page}-btn-${this.name}`).clientWidth + 2;
      this.cdr.detectChanges();
    }
  }

  writeValue(value: any) {
    this.value = value;
    this.optionList && this.optionList.length > 0 && this.select(value);
  }

  registerOnChange(onChange: Function) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: Function) {
    this.onTouch = onTouch;
  }

  select(value: String) {
    const newOption = this.optionList.find(x => x.value === value);
    if (this.currentOption != newOption) {
      this.currentOption = newOption;
      if (newOption) {
        this.value = newOption.value;
      }
      this.isOpenMenu = false;
      this.onChange && this.onChange(this.value);
    }
  }

  hideOption(index) {
    this.optionList[index].error = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/icon-dropdown/icon-dropdown.component.ts